import {
  OBTENER_PLATOS,
  ALMACENANDO_PLATO,
  PREPARANDO_PLATO,
  LIMPIAR_ESTADO_PLATOS,
  SELECCIONAR_PLATO,
  DESELECCIONAR_PLATO,
} from "../types";

// eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case OBTENER_PLATOS:
      return {
        ...state,
        platos: action.payload,
      };

    case ALMACENANDO_PLATO:
      return {
        ...state,
        guardando: true,
      };

    case PREPARANDO_PLATO:
      return {
        ...state,
        guardando: false,
      };

    case SELECCIONAR_PLATO:
      return {
        ...state,
        plato: action.payload,
      };

    case DESELECCIONAR_PLATO:
      return {
        ...state,
        plato: null,
      };

    case LIMPIAR_ESTADO_PLATOS:
      return {
        ...state,
        platos: [],
        plato: null,
        guardando: false,
      };

    default:
      return state;
  }
};
